






  import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
  import AbpBase from "../../../lib/abpbase";
  let echarts = require("echarts");
  require("echarts/lib/chart/line");
  require("echarts/lib/component/tooltip");
  require("echarts/lib/component/title");
  @Component
  export default class Echarts extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({type:String}) legenddata:string;
    @Prop({type:String}) xAxisdata:string;
    @Prop({type:String}) seriesdata:string;
    @Prop({type:String}) strtitle:string;
    @Prop({type:String}) yAxisdata:string;

    option = {
    title: {
        text: ''
    },
    tooltip: {
        trigger: 'axis'
    },
    legend: {
        data: []
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    toolbox: {
        feature: {
            saveAsImage: {}
        }
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: []
    },
    yAxis: {
        type: 'value'
    },
    series: [
        
    ]
};

    drawLine() {
      var myChart = echarts.init(this.$el);
      myChart.setOption(this.option);
    }

    mounted() {
      if(this.seriesdata!=""){
       //console.log(this.strtitle+"123");
       this.option.legend.data=JSON.parse(this.legenddata);
       this.option.xAxis.data=JSON.parse(this.xAxisdata);
      this.option.series=JSON.parse(this.seriesdata);
      this.option.title.text=this.strtitle;
      }
      this.drawLine();
    }
  }
